import React, { useState, useEffect } from "react";
import { CiEdit } from "react-icons/ci";
import { FaRegCalendarAlt } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { SiSpeedtest } from "react-icons/si";
import ReactModal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { deleteOperdon, selectDelSuccessOperdonState, resetDeleteState as resetOperdonDelete } from "../../redux/operdon/operdon-del-slice";
import ServiceIcon from "../operate/card-two-side/service-icon";
import { toast } from "react-toastify";

const CardTwoRow = ({
  operdon,
  categoryId,
  serviceType,
  serviceTitle,
  operDate,
  operKM,
  cost,
  car_title
}) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  // const deleteSuccess = useSelector(selectDelSuccessOperdonState);

  // باز کردن و بستن مدال
  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    setIsOpen(false);
    toast.info("عملیات حذف لغو گردید!", {
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  // // بعد از حذف موفق، پیام بده و state ریست کن
  // useEffect(() => {
  //   if (deleteSuccess) {
  //     // نمایش پیام موفقیت
  //     toast.success("عملیات حذف با موفقیت انجام شد.", {
  //       autoClose: 1000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });

  //     // ریست کردن وضعیت deleteSuccess بعد از مدت زمانی که پیام نشان داده شد
  //     const timer = setTimeout(() => {
  //       dispatch(resetOperdonDelete()); // Reset delete state after the toast message disappears
  //     }, 1000); // This is the same time as the autoClose of the toast message

  //     // پاک کردن تایمر در صورت تغییر وضعیت
  //     return () => clearTimeout(timer);
  //   }
  // }, [deleteSuccess, dispatch]);

  // حذف اپردون
  const handleDelete = () => {
    dispatch(deleteOperdon(operdon.id));
    setIsOpen(false);
  };

  return (
    <div
      className="card mb-3 mx-auto shadow-sm"
      style={{
        maxWidth: "360px",
        direction: "rtl",
        fontFamily: "Yekan, sans-serif",
        backgroundColor: "#f8f9fa",
        borderRadius: "0.375rem",
      }}
    >
      <div
        className="card-header d-flex justify-content-between align-items-center bg-primary text-white rounded-top"
        style={{ padding: "0.5rem 1rem" }}
      >
        <div
          className="d-flex align-items-center gap-2 flex-grow-1"
          style={{ minWidth: 0 }}
        >
          <ServiceIcon categoryId={categoryId} />
          <div className="text-truncate-0" style={{ lineHeight: "1.2" }}>
            <div>{serviceTitle}</div>
            <div className="text-white-50">{car_title}</div>
          </div>
        </div>

        <div className="d-flex gap-2">
          <button
            className="btn btn-danger btn-sm d-flex align-items-center justify-content-center"
            onClick={openModal}
            title="حذف"
          >
            <RiDeleteBinLine />
          </button>
          <Link
            className="btn btn-warning btn-sm d-flex align-items-center justify-content-center"
            to={"/edit-operdon/" + operdon.id}
            state={operdon}
            title="ویرایش"
          >
            <CiEdit />
          </Link>

          {serviceType === "km" ? (
              <SiSpeedtest size={20} />
            ) : (
              <FaRegCalendarAlt size={20} />
          )}
        </div>
      </div>

      <div
        className="card-body"
        style={{ padding: "0.75rem 1rem", color: "#212529" }}
      >
        <div
          className="d-flex justify-content-between mb-2"
          style={{ fontSize: "14px" }}
        >
          <div className="d-flex flex-column text-end">
            <span style={{ fontWeight: "bold" }}>کیلومتر انجام</span>
            <span>{operKM}</span>
          </div>
          <div className="d-flex flex-column text-end">
            <span style={{ fontWeight: "bold" }}>تاریخ انجام</span>
            <span>{operDate}</span>
          </div>
        </div>

        <div
          className="d-flex flex-column text-end"
          style={{ fontSize: "14px" }}
        >
          <span style={{ fontWeight: "bold" }}>هزینه (تومان)</span>
          <span>{cost}</span>
        </div>
      </div>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        style={{
          overlay: {
            zIndex: 1050,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
          },
          content: {
            position: "relative",
            inset: "auto",
            padding: "1.5rem",
            borderRadius: "0.5rem",
            maxWidth: "500px",
            width: "100%",
            maxHeight: "90vh",
            overflowY: "auto",
            direction: "rtl",
          },
        }}
      >
        <h4 className="mb-3">آیا از حذف این سابقه اطمینان دارید؟</h4>
        <p className="mb-1 fw-bold">{car_title} - {serviceTitle}</p>
        <p className="mb-1">تاریخ انجام: {operDate}</p>
        <p className="mb-3">کیلومتر انجام: {operKM}</p>
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button className="btn btn-secondary" onClick={closeModal}>
            خیر
          </button>
          <button className="btn btn-danger" onClick={handleDelete}>
            بلی
          </button>
        </div>
      </ReactModal>
    </div>
  );
};

export default CardTwoRow;
